var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.223 866.01C309.22 870.319 370.975 854.88 375.284 729.216C379.951 599.961 307.425 555.798 199.353 551.848C91.6406 547.899 15.8831 586.675 11.2156 715.93C6.90707 841.954 67.2258 861.702 188.223 866.01Z",
    fill: "#072F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902.717 865.652C781.72 869.96 719.964 854.521 715.656 728.856C710.988 599.601 783.514 555.439 891.586 551.49C999.299 547.541 1075.06 586.317 1079.72 715.572C1084.03 841.237 1023.71 861.343 902.717 865.652Z",
    fill: "#072F73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.88 68.9531C551.389 68.9531 559.098 76.6623 559.098 86.172V481.118C559.098 490.628 551.389 498.337 541.88 498.337C532.37 498.337 524.661 490.628 524.661 481.118V86.172C524.661 76.6623 532.37 68.9531 541.88 68.9531Z",
    fill: "#072F73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M545.47 496.913C632.358 496.913 676.161 483.988 676.161 393.868C676.161 300.876 623.023 271.076 545.47 271.076C467.917 271.076 414.778 300.876 414.778 393.868C414.778 484.347 458.582 496.913 545.47 496.913Z",
    fill: "url(#paint0_linear_15189_95542)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M542 196C596.124 196 640 152.124 640 98.0004C640 43.8766 596.124 0 542 0C487.877 0 444 43.8766 444 98.0004C444 152.124 487.877 196 542 196Z",
    fill: "#0096FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M542 196C596.124 196 640 152.124 640 98.0004C640 43.8766 596.124 0 542 0C487.877 0 444 43.8766 444 98.0004C444 152.124 487.877 196 542 196Z",
    fill: "url(#paint1_linear_15189_95542)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.47 1080C831.267 1080 975.961 1037.99 975.961 741.063C975.961 435.159 800.749 337.141 545.47 337.141C290.191 337.141 114.979 435.159 114.979 741.063C114.979 1037.99 259.673 1080 545.47 1080Z",
    fill: "url(#paint2_linear_15189_95542)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M724.272 475.731C604.711 465.678 486.227 465.678 366.666 475.731C319.273 479.681 277.265 522.766 264.698 566.569C245.31 660.279 237.052 749.68 242.438 845.544C249.618 890.066 291.267 933.868 337.584 938.536C476.892 952.18 614.046 952.18 753.713 938.536C797.158 930.637 844.911 892.22 848.86 845.544C854.246 749.68 845.987 660.279 826.599 566.569C816.186 520.253 769.511 482.912 724.272 475.731Z",
    fill: "#072F73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.565 738.559C497.565 731.931 502.938 726.559 509.565 726.559H581.374C588.001 726.559 593.374 731.931 593.374 738.559C593.374 745.186 588.001 750.559 581.374 750.559H509.565C502.938 750.559 497.565 745.186 497.565 738.559Z",
    fill: "#35DE90"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.515 725.291C361.828 729.977 361.828 737.575 366.515 742.261C371.201 746.948 378.799 746.948 383.485 742.261L400.427 725.319L417.372 742.264C422.058 746.951 429.656 746.951 434.343 742.264C439.029 737.578 439.029 729.98 434.343 725.294L417.398 708.349L434.261 691.485C438.948 686.799 438.948 679.201 434.261 674.515C429.575 669.828 421.977 669.828 417.291 674.515L400.427 691.378L383.567 674.517C378.88 669.831 371.282 669.831 366.596 674.517C361.91 679.204 361.91 686.802 366.596 691.488L383.457 708.349L366.515 725.291Z",
    fill: "#35DE90"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.515 725.291C653.828 729.977 653.828 737.575 658.515 742.261C663.201 746.948 670.799 746.948 675.485 742.261L692.427 725.319L709.372 742.264C714.058 746.951 721.656 746.951 726.343 742.264C731.029 737.578 731.029 729.98 726.343 725.294L709.398 708.349L726.261 691.485C730.948 686.799 730.948 679.201 726.261 674.515C721.575 669.828 713.977 669.828 709.291 674.515L692.427 691.378L675.567 674.517C670.88 669.831 663.282 669.831 658.596 674.517C653.91 679.204 653.91 686.802 658.596 691.488L675.457 708.349L658.515 725.291Z",
    fill: "#35DE90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002.27 310.3C1038.27 280.292 1061.17 235.115 1061.17 184.587C1061.17 94.2405 987.934 21 897.587 21C807.24 21 734 94.2405 734 184.587C734 274.934 807.24 348.174 897.587 348.174C904.883 348.174 912.068 347.697 919.112 346.771V366.785C919.112 376.757 931.168 381.75 938.219 374.699L1000.74 312.179C1001.33 311.585 1001.84 310.955 1002.27 310.3Z",
    fill: "#F6F6F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M896.838 88.8062C878.24 88.8062 860.06 94.321 844.597 104.653C829.133 114.986 817.081 129.671 809.964 146.853C802.847 164.035 800.985 182.942 804.613 201.182C808.241 219.423 817.197 236.178 830.347 249.328C843.498 262.479 860.253 271.434 878.493 275.063C896.733 278.691 915.64 276.829 932.822 269.712C950.004 262.595 964.69 250.542 975.022 235.079C985.354 219.615 990.869 201.435 990.869 182.838C990.869 170.489 988.437 158.262 983.712 146.853C978.986 135.445 972.06 125.079 963.328 116.347C954.596 107.616 944.23 100.689 932.822 95.9639C921.414 91.2384 909.186 88.8062 896.838 88.8062ZM931.065 204.841C932.65 206.443 933.539 208.606 933.539 210.859C933.539 213.113 932.65 215.275 931.065 216.877C929.452 218.44 927.293 219.313 925.047 219.313C922.801 219.313 920.643 218.44 919.029 216.877L896.838 194.78L874.646 217.065C873.033 218.628 870.874 219.502 868.628 219.502C866.382 219.502 864.224 218.628 862.61 217.065C861.025 215.463 860.136 213.301 860.136 211.047C860.136 208.794 861.025 206.631 862.61 205.029L884.896 182.838L862.61 160.646C861.277 159.003 860.6 156.924 860.71 154.811C860.82 152.698 861.709 150.701 863.205 149.205C864.701 147.709 866.698 146.82 868.811 146.71C870.924 146.6 873.003 147.277 874.646 148.61L896.838 170.896L919.029 148.61C920.672 147.277 922.751 146.6 924.864 146.71C926.977 146.82 928.974 147.709 930.47 149.205C931.967 150.701 932.855 152.698 932.965 154.811C933.075 156.924 932.398 159.003 931.065 160.646L908.78 182.838L931.065 204.841Z",
    fill: "#E60F0F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15189_95542",
    x1: 511.908,
    y1: 506.593,
    x2: 586.579,
    y2: 255.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468921,
    stopColor: "#CEDEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1687,
    stopColor: "#E0E8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#ECF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15189_95542",
    x1: 605.981,
    y1: -9.45768,
    x2: 467.308,
    y2: 223.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0033FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0033FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15189_95542",
    x1: 435.08,
    y1: 1111.58,
    x2: 680.773,
    y2: 286.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468921,
    stopColor: "#CEDEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1687,
    stopColor: "#E0E8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#ECF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot4);
export default __webpack_public_path__ + "static/media/robot-4.40c8fa33bf641d1c4a21aec4ad73dfcb.svg";
export { ForwardRef as ReactComponent };